import React from "react";
import middleware from "./middleware/middleware";
import Login from "../component/sections/auth/Login";
import Logout from "../component/sections/auth/Logout";
import ComeBackFromGoogle from "../component/sections/auth/ComeBackFromGoogle";
import UserIsNotPublisher from "../component/partials/other/UserIsNotPublisher";

const authRoutes = [
  {
    path: "/login",
    render: () => {
      return middleware(["isUserLogout"], <Login />, "Login");
    },
    exact: true,
  },
  {
    path: "/logout",
    render: () => {
      return middleware(["isUserLogin"], <Logout />, "Logout");
    },
  },
  {
    path: "/you-are-not-publisher",
    render: () => {
      return middleware(["isUserLogin"], <UserIsNotPublisher />);
    },
    exact: true,
  },
  {
    path: "/come-back-from-google",
    render: () => {
      return middleware(
        ["isUserLogout"],
        <ComeBackFromGoogle />,
        "ComeBackFromGoogle"
      );
    },
    exact: true,
  },
];

export default authRoutes;
